import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedWalletService } from '../../services/wallet.service';
import * as WalletActions from './wallet.actions';

@Injectable()
export class SharedWalletEffects {
  loadWalletWhitelistAddresses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WalletActions.loadWalletWhitelistAddresses),
      switchMap(({ walletId, query }) =>
        this.sharedWalletService
          .getWalletWhitelistAddresses(walletId, query)
          .pipe(
            map(response =>
              WalletActions.loadWalletWhitelistAddressesSuccess({ response })
            ),
            catchError(error =>
              of(
                WalletActions.loadWalletWhitelistAddressesFailure({
                  error:
                    error?.message ||
                    'Failed to load wallet whitelist addresses',
                })
              )
            )
          )
      )
    )
  );

  loadWalletDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WalletActions.loadWalletDetails),
      switchMap(({ walletId, addresses, settings, assetNetwork, vault }) =>
        this.sharedWalletService
          .getWalletDetails(walletId, addresses, settings, assetNetwork, vault)
          .pipe(
            map(response =>
              WalletActions.loadWalletDetailsSuccess({
                data: response.data,
              })
            ),
            catchError(error =>
              of(
                WalletActions.loadWalletDetailsFailure({
                  error:
                    error?.error?.message ||
                    error?.message ||
                    'خطا در بارگذاری جزئیات کیف پول',
                })
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private sharedWalletService: SharedWalletService,
    private router: Router
  ) {}
}
